import React from 'react';
import { Icon } from '@app/src/common/Icon';
import { Calendar } from '../Calendar/Calendar';
import { DateSelectedModel } from '@app/src/views/StepTwo/channelPublication';
import { CategoryModel } from '@app/src/views/Home/listProducts';
import {
  DateWrapper,
  DateSelected,
  IconWrapper,
  SubTitle
} from './styled';

interface Props {
  currentDateSelected?: DateSelectedModel[];
  categoryTheme?: CategoryModel;
  handleClickDateSelected: Function;
  handleClickDay: Function;
}

export const SectionDateSelected: React.FC<Props> = ({
  currentDateSelected,
  categoryTheme,
  handleClickDateSelected,
  handleClickDay
}) => {
  return (
  <React.Fragment>
    <DateWrapper>
    {currentDateSelected && currentDateSelected.length > 0 && currentDateSelected.map((day, index) => (
      <DateSelected
        key={index}
        color={`rgba(${categoryTheme && categoryTheme.colorRgba}, .1)`}
      >
        <span>{day && day.fullDate}</span>
        <IconWrapper onClick={() => handleClickDateSelected(day)}>
          <Icon
            data-name="icon-close-bold"
            width="10"
            height="10"
            fill={ categoryTheme && categoryTheme.color}
          />
        </IconWrapper>
      </DateSelected>
    ))}
    </DateWrapper>
    <SubTitle>Seleccionar fecha de publicación</SubTitle>
    <Calendar
      onClickDay={handleClickDay}
      dateSelected={currentDateSelected}
      categoryId={categoryTheme && categoryTheme.id}
    />
  </React.Fragment>
)};